export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10941.8d732595.jpg";